export default __webpack_public_path__ + "static/media/more-icon.44134bb9.svg";